import { useState } from "react";

import { getConfig } from "site-config";
import { fetchJSON } from "lib/fetch";

import { TAPIResponse } from "../../types";
import { API_STATES } from "../../helpers";

export type TAcceptSmartOrderProducts = [];

export type TAcceptSmartOrderProductsResponse = TAPIResponse<TAcceptSmartOrderProducts, string> & {
    acceptSmartOrderProducts: (selectedProductsIds: string[]) => void;
};

export const useAcceptSmartOrderProducts = (): TAcceptSmartOrderProductsResponse => {
    const { api } = getConfig();

    const acceptSmartOrderProducts = (selectedProductsIds: string[]) => {
        APIStates.pending();

        fetchJSON<TAcceptSmartOrderProducts>(`${api}/api/v3.0/smart-orders/accept`, {
            method: "POST",
            body: JSON.stringify(selectedProductsIds),
        })
            .then((data) => {
                APIStates.success(data);
            })
            .catch((error) => {
                APIStates.error(error);
            });
    };

    const [state, setState] = useState<TAcceptSmartOrderProductsResponse>({
        ...API_STATES.default,
        acceptSmartOrderProducts,
    });

    const APIStates = API_STATES.getStates(setState);

    return {
        ...state,
        acceptSmartOrderProducts,
    };
};
